import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, screenCaptureAnalytics } from '../../../../utils/Utils'
import { useNavigate } from 'react-router-dom';
import { APP_CONSTANTS, ROUTES } from '../../../../utils/AppConstants';
import { businessLocationListRequest } from '../../../../redux/business-location/businessLocation.action'
import { userBusinessListRequest } from '../../../../redux/business/business.action'
import Select from 'react-select'
import moment from "moment";
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../../utils/PermissionUtil";

const LocationListScreen = props => {
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    let navigate = useNavigate();
    const LOCATION_LIST = 'LOCATION_LIST'
    const EDIT_LOCATION = 'EDIT_LOCATION'
    const ADD_LOCATION = 'ADD_LOCATION'

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.LOCATION_LIST, true)
            setLoading(true)
            const data = {
                userId: user.data.userDetails.userId
            }
            if (isNull(userBusinessListSuccess))
                dispatch(userBusinessListRequest(data))
        }
    }, [])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.LOCATION_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.LOCATION_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isNull(userBusinessListError)) {
            setLoading(false)
        }

    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isNull(businessLocationListSuccess)) {
            setLoading(false)
        } else if (!isNull(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserEmployee(user) === true && !isNull(employeeSelectedBusiness)) {
            fetchLocationListReq(employeeSelectedBusiness)
        }
    }, [employeeSelectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchLocationListReq(selectedBusiness.businessId)
        }
    }, [selectedBusiness])

    const fetchLocationListReq = (businessId) => {
        setLoading(true)
        dispatch(businessLocationListRequest(businessId))
    }

    const addLocationClickHandle = () => {
        navigate(ROUTES.location.add)
    }

    const handleCardClick = element => {
        navigate(ROUTES.location.detail, { state: element.locationId });
    }

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.LOCATION, PERMISSION_SUB_TYPE.LOCATION.ADD_LOCATION, employeeSelectedBusiness, employeeSelectedLocation)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Locations' />
                {isLoggedInUserBusiness(user) === true && !isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                    className='select-full-width-no-border'
                    value={selectedBusiness}
                    getOptionLabel={e => e.businessName}
                    getOptionValue={e => e}
                    options={userBusinessListSuccess.data}
                    placeholder='Select Business'
                    onChange={e => setSelectedBusiness(e)} />}
                {isLoggedInUserBusiness(user) === true && !isEmpty(userBusinessListError) && <div className="content-error">{userBusinessListError.message}</div>}
                <div className="table-scroll-container">
                    {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Address</th>
                                <th scope="col" className="text-center">Location</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Action</th>
                                {/* <th scope="col" className="loc-table-col-title text-center">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {businessLocationListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td >{element.name}</td>
                                    <td >{element.address ? element.address : '-'}</td>
                                    <td className="text-center">{element.city ? element.city : '-'}, {element.state ? element.state : '-'}, {element.country ? element.country : '-'}</td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In-Active'}</div>
                                    </td>
                                    <td className="text-center">{moment(element.createdOn).utc().format('DD MMM YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleCardClick(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                    {/* <td className="loc-table-col-item">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleCardDetailClick(element) }}>Detail</div>
                                            <div className="loc-list-button" onClick={() => { handleCardClick(element) }}>Edit</div>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}

                        </tbody>
                    </table>}
                </div>
                {!isEmpty(businessLocationListError) && <div className="content-error">{businessLocationListError.message}</div>}
                {isPermissionAllowed() &&
                    <div className="vl-fab-container" onClick={() => addLocationClickHandle()}>
                        <img src={require('../../../../assets/plus_icon.png')} className="vl-fab-icon" />
                    </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default LocationListScreen